(() => {
  const start = () => {
    const header = document.querySelector('.site-header');
    if (!header || header.dataset.pkNotchReady) return;
    header.dataset.pkNotchReady = 'true';
    const menuButton = header.querySelector('[data-menu-toggle]');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    let lastY = Math.max(0,scrollY), travel = 0, direction = 0, scheduled = false, over = false;
    const reveal = () => header.classList.remove('is-tucked');
    const update = () => {
      scheduled = false;
      const y = Math.max(0,scrollY);
      const delta = y-lastY;
      lastY=y;
      const menuOpen=menuButton?.getAttribute('aria-expanded')==='true';
      header.classList.toggle('is-compact',y>48);
      header.classList.toggle('is-menu-open',menuOpen);
      if (y<120 || menuOpen || over || header.contains(document.activeElement) || reduce.matches) {
        reveal(); travel=0; direction=0; return;
      }
      if (Math.abs(delta)<.5) return;
      const nextDirection=Math.sign(delta);
      if (nextDirection!==direction) {travel=0; direction=nextDirection;}
      travel+=Math.abs(delta);
      if (direction<0 && travel>=8) reveal();
      else if (direction>0 && travel>=32) header.classList.add('is-tucked');
    };
    const queue=() => {if (!scheduled) {scheduled=true; requestAnimationFrame(update);}};
    addEventListener('scroll',queue,{passive:true});
    addEventListener('resize',queue,{passive:true});
    header.addEventListener('pointerenter',() => {over=true; reveal();});
    header.addEventListener('pointerleave',() => {over=false;});
    header.addEventListener('focusin',reveal);
    header.addEventListener('focusout',queue);
    if (menuButton) new MutationObserver(queue).observe(menuButton,{attributes:true,attributeFilter:['aria-expanded']});
    reduce.addEventListener('change',queue);
    header.querySelectorAll('nav a').forEach(link => {
      const target=new URL(link.href,location.href);
      if (target.origin===location.origin && target.pathname.replace(/\/$/,'')===location.pathname.replace(/\/$/,'')) link.setAttribute('aria-current','page');
    });
    update();
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',start);
})();